import { getApiUrl } from "../../constants/pathConstants"
import { adminStateData } from "../../data/adminStateData"
import { userStateData } from "../../data/userStateData"
import { AccountStatus } from "../../types/types"
import { API_END_POINT_LOGIN, API_END_POINT_LOGIN_ADMIN, API_END_POINT_PASSWORD_RESET, API_END_POINT_REQUEST_PASSWORD_RESET } from "../endPoints"
import { UserData } from "../types"
// import { LoginResponse, UserData } from "../types"
// import { instructorStateData } from "../../data/instructorStateData"
// import { InstructorReviewsResponse } from "../types"

class LoginConnector {
	requestInProgress: boolean = false

	public async performLoginRequest(email: string, password: string): Promise<boolean> {
		try {
			if (this.requestInProgress) {
				console.log('WARNING - [LoginConnector] performLoginRequest() called while request is in process')
				return false
			} else {
				this.requestInProgress = true

				await fetch(`${getApiUrl()}${API_END_POINT_LOGIN}`,{
					// credentials: 'same-origin',
					method: 'post',
					headers: {'Content-Type':'application/json'},
					body: JSON.stringify({
						"email": email,
						"password": password
					})
				})
					.then((res) => res.json())
					// .then((data: LoginResponse) => {
					.then((data) => {
						// if (data.reviews) {
						// 	instructorStateData.addReviews(data.reviews)
						// } else {
						// 	// TODO: add error handling for searches which don't return values
						// }
						if (data.status === 'success') {
							// userStateData.userData = data.userData
							// userStateData.loggedIn = true
							if (data.userData?.status !== AccountStatus.VERIFY_EMAIL) {
								userStateData.setUserData(data.userData as UserData)
							}
						} else {
							// return false
						}
						// console.log('login data =', data)
					})
					.catch((error) => {
						console.log(error)
					})
				
				this.requestInProgress = false
				return userStateData.loggedIn
			}
			// return true
		} catch(err) {
			this.requestInProgress = false
			console.log('[LoginConnector] - performLoginRequest() failed')
			console.log(err)
			return false
		}
	}

	public async performAdminLoginRequest(email: string, password: string): Promise<boolean> {
		try {
			if (this.requestInProgress) {
				console.log('WARNING - [LoginConnector] performAdminLoginRequest() called while request is in process')
				return false
			} else {
				this.requestInProgress = true
				await fetch(`${getApiUrl()}${API_END_POINT_LOGIN_ADMIN}`,{
					method: 'post',
					headers: {'Content-Type':'application/json'},
					body: JSON.stringify({
						"email": email,
						"password": password
					})
				})
					.then((res) => res.json())
					.then((data) => {
						adminStateData.setLoggedIn(data.status === 'success')
					})
					.catch((error) => {
						console.log(error)
					})
				this.requestInProgress = false
				return adminStateData.loggedIn
			}
		} catch(err) {
			this.requestInProgress = false
			console.log('[LoginConnector] - performAdminLoginRequest() failed')
			console.log(err)
			return false
		}
	}

	public async performResetPasswordRequest(email: string): Promise<boolean> {
		try {
			if (this.requestInProgress) {
				console.log('WARNING - [LoginConnector] performResetPasswordRequest() called while request is in process')
				return false
			} else {
				this.requestInProgress = true
				await fetch(`${getApiUrl()}${API_END_POINT_REQUEST_PASSWORD_RESET}`,{
					method: 'post',
					headers: {'Content-Type':'application/json'},
					body: JSON.stringify({
						"email": email
					})
				})
				.catch((error) => {
					console.log(error)
				})
				this.requestInProgress = false
				return true
			}
		} catch(err) {
			this.requestInProgress = false
			console.log('[LoginConnector] - performAdminLoginRequest() failed')
			console.log(err)
			return false
		}
	}

	public async performPasswordResetRequest(email: string, password: string, resetCode: string): Promise<boolean> {
		try {
			if (this.requestInProgress) {
				console.log('WARNING - [LoginConnector] performResetPasswordRequest() called while request is in process')
				return false
			} else {
				this.requestInProgress = true
				await fetch(`${getApiUrl()}${API_END_POINT_PASSWORD_RESET}`,{
					method: 'post',
					headers: {'Content-Type':'application/json'},
					body: JSON.stringify({
						"email": email,
						"password": password,
						"resetCode": resetCode
					})
				})
				.catch((error) => {
					console.log(error)
				})
				this.requestInProgress = false
				return true
			}
		} catch(err) {
			this.requestInProgress = false
			console.log('[LoginConnector] - performPasswordResetRequest() failed')
			console.log(err)
			return false
		}
	}

	public async performAppPasswordResetRequest(password: string, resetCode: string): Promise<boolean> {
		try {
			if (this.requestInProgress) {
				console.log('WARNING - [LoginConnector] performAppPasswordResetRequest() called while request is in process')
				return false
			} else {
				this.requestInProgress = true
				await fetch(`${getApiUrl()}${API_END_POINT_PASSWORD_RESET}`,{
					method: 'post',
					headers: {'Content-Type':'application/json'},
					body: JSON.stringify({
						"password": password,
						"resetCode": resetCode
					})
				})
				.catch((error) => {
					console.log(error)
				})
				this.requestInProgress = false
				return true
			}
		} catch(err) {
			this.requestInProgress = false
			console.log('[LoginConnector] - performAppPasswordResetRequest() failed')
			console.log(err)
			return false
		}
	}
}

export const loginConnector: LoginConnector = new LoginConnector()